var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ backgroundColor: _vm.visualSettings.bodyBackgroundColor }),attrs:{"id":"app"}},[_c('Chat'),_c('notifications',{staticClass:"app-notifications",attrs:{"group":"app","classes":"notification-style"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }